
(function() {
  var result = { translations: { "sl": { "i18n": { "duration": { "seconds": "{{ seconds }} sekund", "minutes": "{{ minutes }} min", "hours": "{{ hours }} ur", "hoursAndMinutes": "{{ hours }} ur {{ minutes }} minut", "days": "{{ days }} dni", "shortForm": { "seconds": "{{ seconds }} sekund", "minutes": "{{ minutes }} minut", "hours": "{{ hours }} ur", "days": "{{ days }} dni", "hoursAndMinutes": "{{ hours }} ur {{ minutes }} minut" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, zun. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "sl": "static-7.1003"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1003",
    "ar-eg": "static-7.1003",
    "bg": "static-7.1003",
    "bn": "static-7.1003",
    "ca-es": "static-7.1003",
    "cs": "static-7.1003",
    "da": "static-7.1003",
    "de": "static-7.1003",
    "el": "static-7.1003",
    "en-gb": "static-7.1003",
    "en": "static-7.1003",
    "es-mx": "static-7.1003",
    "es": "static-7.1003",
    "fi": "static-7.1003",
    "fr-ca": "static-7.1003",
    "fr": "static-7.1003",
    "he-il": "static-7.1003",
    "hr": "static-7.1003",
    "hu": "static-7.1003",
    "id": "static-7.1003",
    "it": "static-7.1003",
    "ja": "static-7.1003",
    "ko": "static-7.1003",
    "lt": "static-7.1003",
    "ms": "static-7.1003",
    "nl": "static-7.1003",
    "no": "static-7.1003",
    "pl": "static-7.1003",
    "pt-br": "static-7.1003",
    "pt-pt": "static-7.1003",
    "ro": "static-7.1003",
    "ru": "static-7.1003",
    "sk": "static-7.1003",
    "sl": "static-7.1003",
    "sv": "static-7.1003",
    "th": "static-7.1003",
    "tl": "static-7.1003",
    "tr": "static-7.1003",
    "uk": "static-7.1003",
    "vi": "static-7.1003",
    "x-pseudo": "static-7.1003",
    "zh-cn": "static-7.1003",
    "zh-hk": "static-7.1003",
    "zh-tw": "static-7.1003"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:sl', {version: 'static-7.1003'}); }
})();


